import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class EthicsCommitteeService extends CrudService {

  constructor(public override http: HttpClient) {
    super('ethics-committee', http);
  }

  /**
   * Check EthicsCommittee field is unique
   * @returns object
   */
  checkUniqueEthicsCommittee(ethicsCommitteeName: string, id: number) {
    return this.http.get(
      `${this.baseUrl}/check-unique-ethics-committee/${ethicsCommitteeName}/${id}`
    );
  }

}
